import React from 'react';
import Modal from 'react-modal';
import CustomButton from '../button/CustomButton';
import { CloseIcon } from './components';

const customStyles = {
  overlay: {
    backgroundColor: '#000000bb',
    zIndex: 44444444,
  },
  content: {
    backgroundColor: 'transparent',
    zIndex: '255',
    top: '50%',
    left: '50%',
    right: 'auto',
    justifyContent: 'center',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    color: '#001212',
    borderRadius: '8px',
    border: 'none',
    padding: '0 ',
  },
};

const MediaModal = ({ url, type, onClose, deleteFile }) => {
  return (
    <Modal
      onRequestClose={onClose}
      isOpen={!!url}
      style={customStyles}
      contentLabel="Crop Image"
      ariaHideApp={false}
    >
      <CloseIcon onClick={onClose} />
      {type === 'image' ? (
        <img src={url} style={{ maxWidth: '80vw', maxHeight: '90vh' }} alt="media_modal_image" />
      ) : (
        <video
          controls
          autoPlay
          style={{
            maxWidth: '80vw',
            maxHeight: '90vh',
            width: '80vh',
            height: 'auto',
            display: 'block',
          }}
        >
          <source src={url} />
        </video>
      )}
      {deleteFile && <CustomButton onClick={deleteFile}>Delete</CustomButton>}
    </Modal>
  );
};

export default MediaModal;
